import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Table, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils/helper";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import { useLocation } from "react-router-dom";

import { AuthorizationModal } from "../Modal/AuthorizationModal/AuthorizationModal";
import { getAuthorizations, getRedirectData } from "../../reducers/selectors";
import { authorizationsReload } from "../../actions/entities";
import { getTransactionalPinURL, respondAuthorization } from "../../services/api/authorizations";
import { setRedirectionData } from "../../services/api/entities";
import { Grid } from "./Grid/Grid";

const AuthorizationComponent = () => {
  const [loading, setLoading] = useState(false);
  const authorizations = useSelector(getAuthorizations);
  const dispatch = useDispatch();

  let { state } = useLocation();

  useEffect(() => {
    if (state) {
      handleAuthorizeWrapper(state.redirectionData);
    }
  }, [state]);

  const handleAuthorizeWrapper = (payload) => {
    if (payload.accepted) {
      handleAuthorize(payload);
    } else {
      handleReject(payload);
    }
  };

  const handlePreReject = (authorization) => {
    setLoading(() => true);
    getTransactionalPinURL()
      .then(({ response }) => {
        const pre_pin_validation_token = response.pre_pin_validation_token;
        const redirect_url = response.redirect_url;

        const newRedirectData = {
          id: pre_pin_validation_token,
          data: {
            type: "Authorization",
            payload: { id: authorization.id, accepted: false },
          },
        };
        setRedirectionData(newRedirectData)
          .then(({ response }) => {
            if (response.result.Code === 200) {
              window.location.href = redirect_url;
            } else {
              showToast("Error procesando autorización", true);
              setLoading(() => false);
            }
          })
          .catch((err) => {
            console.error(err);
            showToast("Error procesando autorización", true);
            setLoading(() => false);
          });
      })
      .catch((err) => {
        console.error(err);
        showToast("Error procesando autorización", true);
        setLoading(() => false);
        dispatch(authorizationsReload());
      });
  };

  const handleReject = (payload) => {
    setLoading(() => true);
    respondAuthorization(payload)
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error procesando autorización", true);
        } else {
          showToast("Autorización rechazada correctamente");
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error procesando autorización", true);
      })
      .finally(() => {
        setLoading(() => false);
        dispatch(authorizationsReload());
      });
  };

  const handlePreAuthorize = (authorization) => {
    setLoading(() => true);
    getTransactionalPinURL()
      .then(({ response }) => {
        const pre_pin_validation_token = response.pre_pin_validation_token;
        const redirect_url = response.redirect_url;

        const newRedirectData = {
          id: pre_pin_validation_token,
          data: {
            type: "Authorization",
            payload: { id: authorization.id, accepted: true },
          },
        };
        setRedirectionData(newRedirectData)
          .then(({ response }) => {
            if (response.result.Code === 200) {
              window.location.href = redirect_url;
            } else {
              showToast("Error procesando autorización", true);
              setLoading(() => false);
            }
          })
          .catch((err) => {
            console.error(err);
            showToast("Error procesando autorización", true);
            setLoading(() => false);
            dispatch(authorizationsReload());
          });
      })
      .catch((err) => {
        console.error(err);
        showToast("Error procesando autorización", true);
        setLoading(() => false);
        dispatch(authorizationsReload());
      });
  };

  const handleAuthorize = (payload) => {
    const newData = {
      id: payload.id,
      accepted: true,
    };
    setLoading(() => true);
    respondAuthorization(newData)
      .then(({ response }) => {
        if (response.result.Code !== 200) {
          showToast("Error procesando autorización", true);
        } else {
          showToast("Autorización aprobada correctamente");
        }
      })
      .catch((err) => {
        console.error(err);
        showToast("Error procesando autorización", true);
      })
      .finally(() => {
        setLoading(() => false);
        dispatch(authorizationsReload());
      });
  };

  if (loading) return <CircularProgress />;

  return (
    <Row>
      <Col lg="12">
        <Grid
          authorizations={authorizations}
          onAuthorize={handleAuthorize}
          onReject={handleReject}
          loading={loading}
          setLoading={setLoading}
        />
      </Col>
    </Row>
  );
};
export default AuthorizationComponent;
